import {
  apiRegister
} from '../../common/api';
import {
  isNumber
} from '../../common/utils';
import {
  ERR_REQ_CID
} from '../../common/const';
import {
  KWinner
} from '../../models/kwinner';
import {
  cleanUsers
} from './utils';

/*
协议Id 
897
项目 
模块 
方式 
https 
命令（路径） 
/award/match/luckyusers/
说明
幸运趣味用户
请求参数
参数名称	参数类型	说明
cId	int	比赛配置id
*/

const matchWinnersRank = apiRegister('match-winners', {
  protoId: 897,
  path: '/award/match/luckyusers/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_CID // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    const {
      users,
      userInfos
    } = R
    const {
        pre66,
        pre88,
        pre666,
        pre888,
        preLast,
        final1,
        final2,
        final3,
        final66,
        final88,
        final666,
        final888
      } = users
    return {
      winnerMap: {
        pre66: KWinner(pre66, 66),
        pre88: KWinner(pre88, 88),
        pre666: KWinner(pre666, 666),
        pre888: KWinner(pre888, 888),
        preLast: KWinner(preLast, -1),
        final1: KWinner(final1, 1),
        final2: KWinner(final2, 2),
        final3: KWinner(final3, 3),
        final66: KWinner(final66, 66),
        final88: KWinner(final88, 88),
        final666: KWinner(final666, 666),
        final888: KWinner(final888, 888)
      },
      userMap: cleanUsers(userInfos, true)
    }
  }
})

export const matchWinnersRankLoad = matchWinnersRank.send
